import React from "react";

import TextBodySection from '../components/TextBodySection';

export const termsAndConditionsMarkdown = `
**Última actualización: 21 de febrero de 2025**

### 1. Aceptación de los Términos

Al acceder y navegar por [https://www.equipomag.com](https://www.equipomag.com) (en adelante, el “Sitio Web”), así como al contratar los servicios ofrecidos por **EquipoMAG** (en adelante, el “Titular”), el Usuario acepta los presentes Términos y Condiciones. Si no estás de acuerdo con ellos, te rogamos no utilices el Sitio Web ni contrates nuestros servicios.

---

### 2. Quiénes Somos

EquipoMAG es una entidad dedicada a la asesoría en **nutrición orientada al futuro**, incluidas áreas de **salud integral, naturopatía, psicología y servicios corporativos**. Con más de 25 años de experiencia, ofrecemos soluciones personalizadas para cada cliente.

---

### 3. Servicios Ofrecidos

A través del Sitio Web, el Titular facilita el acceso a información, asesoramiento especializado y contratación de servicios relacionados con:

- Naturopatía alimentaria.  
- Apoyo psicológico.  
- Programas de salud y bienestar corporativo.  
- Otros servicios afines descritos en el Sitio Web.

---

### 4. Uso del Sitio Web

#### 4.1 Condiciones de Acceso

El acceso y navegación en el Sitio Web son gratuitos para los Usuarios. No obstante, la contratación de determinados servicios puede requerir registro previo o pago de una tarifa.

#### 4.2 Veracidad de la Información

El Usuario se compromete a facilitar información veraz, completa y actualizada en cualquier formulario o proceso de registro. El incumplimiento de esta obligación podría conllevar la suspensión de los servicios o la cancelación de la cuenta.

#### 4.3 Conducta del Usuario

El Usuario se compromete a utilizar el Sitio Web de forma diligente, legal y respetuosa, absteniéndose de:

- Publicar o transmitir contenido ilegal, difamatorio o que infrinja derechos de terceros.  
- Realizar acciones que interfieran en el funcionamiento normal del Sitio Web o de los servicios ofrecidos.

---

### 5. Propiedad Intelectual

Los contenidos (textos, imágenes, logotipos, diseños, etc.) del Sitio Web son propiedad de EquipoMAG o de sus licenciantes y están protegidos por la normativa de propiedad intelectual. Queda prohibida la reproducción, modificación, distribución o cualquier forma de explotación no autorizada de dichos contenidos sin consentimiento expreso del Titular.

---

### 6. Política de Privacidad y Protección de Datos

El tratamiento de los datos personales de los Usuarios se rige por la **Política de Privacidad** descrita en este mismo Sitio Web. Al usar el Sitio Web o contratar nuestros servicios, el Usuario confirma que ha leído y acepta dicha política.

---

### 7. Limitación de Responsabilidad

- **Disponibilidad de los servicios:** EquipoMAG trabaja para garantizar la accesibilidad y continuidad del Sitio Web y de sus servicios, pero no puede asegurar la inexistencia de interrupciones eventuales.

- **Contenido de terceros:** El Sitio Web puede incluir enlaces a otros sitios o recursos de terceros sobre los que EquipoMAG no tiene control ni responsabilidad.

- **Uso de la información:** El Usuario asume toda la responsabilidad derivada de las decisiones o acciones basadas en la información disponible en el Sitio Web.

---

### 8. Herramientas de Terceros

Para mejorar la experiencia del Usuario y analizar el uso del Sitio Web, empleamos **Google Analytics** y otras herramientas de terceros que pueden recopilar datos de navegación (por ejemplo, dirección IP, páginas visitadas, tiempo de permanencia). Estas herramientas cumplen con la normativa europea de protección de datos (GDPR).

---

### 9. Modificaciones de los Términos

EquipoMAG se reserva el derecho de modificar en cualquier momento los presentes Términos y Condiciones. Las nuevas versiones se publicarán con la fecha de la última actualización indicada en la parte superior. El uso continuado de los servicios tras la publicación de dichas modificaciones supondrá la aceptación de los cambios por parte del Usuario.

---

### 10. Legislación y Jurisdicción

El uso del Sitio Web y la relación con los Usuarios se rige por la normativa española y europea en materia de protección de datos y servicios digitales (RGPD y demás disposiciones aplicables). Cualquier disputa o conflicto que surja con motivo de los presentes Términos se someterá a los Juzgados y Tribunales de la ciudad de residencia del Titular o del Usuario, en caso de que la normativa de consumo así lo establezca.

---

### 11. Contacto y Soporte

Para cualquier duda o incidencia relacionada con el Sitio Web, los servicios ofrecidos o los presentes Términos y Condiciones, puedes contactar con EquipoMAG a través de los siguientes medios:

- Correo electrónico: **info@equipomag.com**  
- A través del formulario de contacto disponible en [https://www.equipomag.com](https://www.equipomag.com)
`;


const TermsPage = () => {
  return (
    <>
      <TextBodySection
        policyMarkdown={termsAndConditionsMarkdown}
      />
    </>
  );
};

export default TermsPage;
